import PageRenderer from "./PageRenderer";

export default PageRenderer